import api from "api/api";

export const getCurrencyList = async () => await api.get("/settings/currency");

export const getCurrencyById = async (id) =>
  await api.get(`/settings/currency/${id}`);

export const deleteCurrencyById = async (id) =>
  await api.delete(`/settings/currency/${id}`);

export const updateCurrencyById = async (id, data) =>
  await api.put(`/settings/currency/${id}`, data);

export const createCurrency = async (data) =>
  await api.post("/settings/currency", data);

export const getCurrencyListByBranch = async (branch_id) =>
  await api.get(`/settings/currency/branch/${branch_id}`);
